import React, { useEffect, useState } from 'react';
import { Button, Select, IconDownload, IconFilter, ProgressIndicator, IconClipboard } from '@veneer/core';
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import XLSX from 'xlsx';
import { Row, Col, Container, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { history } from "../../../services/helpers/history";
import '../../../assets/scss/analysis.scss';
import Chart from 'chart.js/auto';

const TPIReport = (props) => {
  const [t] = useTranslation();
  const connectApi = new ConnectAPI();

  const [isLoading, setIsLoading] = useState(true);
  const [dataRespond, setDataRespond] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [endUserOptions, setEndUserOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [seriesOptions, setSeriesOptions] = useState([]);
  const [dateOptions, setDateOptions] = useState([]);

  const [countryFilterVal, setCountryFilterVal] = useState([]);
  const [countryFilterValSend, setCountryFilterValSend] = useState([]);
  const [channelFilterVal, setChannelFilterVal] = useState([]);
  const [endUserFilterVal, setEndUserFilterVal] = useState([]);
  const [modelFilterVal, setModelFilterVal] = useState([]);
  const [seriesFilterVal, setSeriesFilterVal] = useState([]);
  const [startDateFilterVal, setStartDateFilterVal] = useState([]);
  const [endDateFilterVal, setEndDateFilterVal] = useState([]);

  const startDate = new Date(startDateFilterVal[0]);
  const endDate = new Date(endDateFilterVal[0]);

  const [viewAnalysisVisible, setViewAnalysisVisible] = useState(false);//cambiar a false

  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate

    connectApi
      .get(
        'api/Channels/TPIReportFilters',
        {
          params: {
            country: 'noFiltered',
            idChannel: 'noFiltered',
            idEndUser: 'noFiltered',
            model: 'noFiltered',
            serie: 0
          },
        },
        filtersLoad
      ).catch((error) => { 
        setIsLoading(false);       
        if(error?.response?.status == 403){
          history.push('/');
        } else {
          Swal.fire(
            'Error ' + error?.response?.status,
            error?.response?.data,
            'error'
          );
        }        
      });

  }, []);

  const filtersLoad = (status, data) => {
    setDataRespond(data);
    setCountryOptions(data.countries.map(x => { return { value: x.id, label: x.name }; }));
    
    //getFilters('noFiltered', 'noFiltered', 'noFiltered', 'noFiltered', 'noFiltered');
    let dataRespond = data;
    setChannelOptions( [...new Map(dataRespond.channels.map(x => [x.id, x.name]) )].map(x => ({ value: x[0], label: x[1] })) );
    setEndUserOptions( [...new Map(dataRespond.endUsers.map(x => [x.id, x.name]) )].map(x => ({ value: x[0], label: x[1] })) );
    setSeriesOptions( [...new Set(dataRespond.series.map(x => x.series) )].map(series => ({ value: series.toString(), label: series.toString() })) );
    setModelOptions( [...new Set(dataRespond.models.map(x => x.model) )].map(model => ({ value: model, label: model})) );


    setDateOptions(data.dates.map(item => {
      return {
        value: moment(item).format('YYYY-MM-DDTHH:mm:ss'),
        label: moment(item).format('MMM') + ' ' + moment(item).format('YYYY'),
      };
    }));

    //set default dates
    setStartDateFilterVal([data.dates[data.dates.length - 1]]);
    setEndDateFilterVal([data.dates[data.dates.length - 1]]);

    setIsLoading(false);

    if(data.countries.length<2) setCountryFilterVal([data.countries[0]])
  }

  function getFilters(country, idChannel, idEndUser, model, serie ) {

    //Filtro de Canales
    setChannelOptions( country === 'noFiltered' ? [...new Map(dataRespond.channels.map(x =>[x.id, x.name]) )].map(x => ({ value: x[0], label: x[1] }))  
      : dataRespond.channels.filter((val, idx, arr) => val.country === country && arr.findIndex(
      item => item.id === val.id && item.country === val.country) === idx ).map(x => ({ value: x.id, label: x.name })
    ));
    
    //Filtro de Usuaios Finales
    setEndUserOptions( idChannel === 'noFiltered' ? [...new Map(dataRespond.endUsers.map(x => [x.id, x.name]) )].map(x => ({ value: x[0], label: x[1] }))
      : dataRespond.endUsers.reverse().filter((val, idx, arr) => val.idChannel === idChannel 
      && arr.findIndex(item => item.id === val.id) === idx).map(x => ({ value: x.id, label: x.name })
    ).reverse());

    //Filtro de Series
    setSeriesOptions( idChannel === 'noFiltered' ? [...new Set(dataRespond.series.map(x => x.series) )].map(series => ({ value: series.toString(), label: series.toString() })) 
      : [...new Set( dataRespond.series.filter(val => val.idChannel === idChannel &&
      (idEndUser === 'noFiltered' || val.idEndUser === idEndUser) && (model === 'noFiltered' || val.model === model) ).map(x => x.series) )].map(
        series => ({ value: series.toString(), label: series.toString() }))
    );

    //Fitro de Modelos
    setModelOptions( idChannel === 'noFiltered' ? [...new Set(dataRespond.models.map(x => x.model) )].map(model => ({ value: model, label: model})) 
      : [...new Set( dataRespond.models.filter(val => val.idChannel === idChannel &&
      (idEndUser === 'noFiltered' || val.idEndUser === idEndUser) && (serie === 0 || val.series === serie) ).map(x => x.model))].map(
        model => ({ value: model, label: model }))
    );

  }

  const GetReport = () => {
    setIsLoading(true);

    const dataResponseLoad = (status, data) => {

      let excelData = data;

      const dataXlsx = excelData;
      const ws = XLSX.utils.json_to_sheet(dataXlsx);
      const wb = XLSX.utils.book_new();

      const date = moment(new Date()).format('YYYYMMDDHHmm');

      const filename = 'tpi -' + date + '.xlsx';
      const ws_name = 'tpi';

      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(wb, filename);

      setIsLoading(false);

    };
    //console.log(countryFilterValSend)
    const parameters = {
      start: startDate.getFullYear().toString() + '-' + (startDate.getMonth() + 1).toString() + '-' + startDate.getDate().toString(),
      end: endDate.getFullYear().toString() + '-' + (endDate.getMonth() + 1).toString() + '-' + endDate.getDate().toString(),
      country: countryFilterValSend.length > 0 ? countryFilterValSend[0] : 'noFiltered',
      idChannel: channelFilterVal.length > 0 ? channelFilterVal[0] : 'noFiltered',
      idEndUser: endUserFilterVal.length > 0 ? endUserFilterVal[0] : 'noFiltered',
      model: modelFilterVal.length > 0 ? modelFilterVal[0] : 'noFiltered',
      series: seriesFilterVal.length > 0 ? parseInt(seriesFilterVal[0]) : 0,
    };

    //console.log(parameters)
    connectApi
      .get(
        'api/Channels/tpiReport',
        {
          params: parameters,
        },
        dataResponseLoad
      )
      .catch((error) => {
        setIsLoading(false);        
        if(error?.response?.status == 403){
          history.push('/');
        } else {
          Swal.fire(
            'Error ' + error?.response?.status,
            error?.response?.data,
            'error'
          );
        }
      });
  };

  const resetFilters = () => {
    setCountryFilterVal([]);
    setCountryFilterValSend([]);
    setChannelFilterVal([]);
    setEndUserFilterVal([]);
    setModelFilterVal([]);
    setSeriesFilterVal([]);
    //set default dates
    setStartDateFilterVal([dateOptions[dateOptions.length - 1].value]);
    setEndDateFilterVal([dateOptions[dateOptions.length - 1].value]);

    //load original values
    getFilters('noFiltered', 'noFiltered', 'noFiltered', 'noFiltered', 'noFiltered');

    setViewAnalysisVisible(false);
  }

  const handleCountryFilterChange = (e) => {
    setCountryFilterVal(e.value === 'noFiltered' ? [] : [e.value]);
    setCountryFilterValSend(e.value === 'noFiltered' ? [] : [e.label]);
    getFilters(
      e.value,
      channelFilterVal.length > 0 ? channelFilterVal[0] : 'noFiltered',
      endUserFilterVal.length > 0 ? endUserFilterVal[0] : 'noFiltered',
      modelFilterVal.length > 0 ? modelFilterVal[0] : 'noFiltered',
      seriesFilterVal.length > 0 ? parseInt(seriesFilterVal[0]) : 'noFiltered',
    );
  }

  const handleChannelFilterChange = (e) => {
    setChannelFilterVal(e.value === 'noFiltered' ? [] : [e.value]);

    getFilters(
      countryFilterVal.length > 0 ? countryFilterVal[0] : 'noFiltered',
      e.value,
      endUserFilterVal.length > 0 ? endUserFilterVal[0] : 'noFiltered',
      modelFilterVal.length > 0 ? modelFilterVal[0] : 'noFiltered',
      seriesFilterVal.length > 0 ? parseInt(seriesFilterVal[0]) : 'noFiltered',
    );

  }

  const handleEndUserFilterChange = (e) => {
    setEndUserFilterVal(e.value === 'noFiltered' ? [] : [e.value]);
    getFilters(
      countryFilterVal.length > 0 ? countryFilterVal[0] : 'noFiltered',
      channelFilterVal.length > 0 ? channelFilterVal[0] : 'noFiltered',
      e.value,
      modelFilterVal.length > 0 ? modelFilterVal[0] : 'noFiltered',
      seriesFilterVal.length > 0 ? parseInt(seriesFilterVal[0]) : 'noFiltered',
    );
  }

  const handleModelFilterChange = (e) => {
    setModelFilterVal(e.value === 'noFiltered' ? [] : [e.value]);
    getFilters(
      countryFilterVal.length > 0 ? countryFilterVal[0] : 'noFiltered',
      channelFilterVal.length > 0 ? channelFilterVal[0] : 'noFiltered',
      endUserFilterVal.length > 0 ? endUserFilterVal[0] : 'noFiltered',
      e.value,
      seriesFilterVal.length > 0 ? parseInt(seriesFilterVal[0]) : 'noFiltered',
    );
  }

  const handleSeriesFilterChange = (e) => {
    setSeriesFilterVal(e.value === 'noFiltered' ? [] : [e.value]);
    getFilters(
      countryFilterVal.length > 0 ? countryFilterVal[0] : 'noFiltered',
      channelFilterVal.length > 0 ? channelFilterVal[0] : 'noFiltered',
      endUserFilterVal.length > 0 ? endUserFilterVal[0] : 'noFiltered',
      modelFilterVal.length > 0 ? modelFilterVal[0] : 'noFiltered',
      parseInt(e.value)
    );
  }

  const GetAnalysis = () => {

    console.log("----------------------Generar Analisis---------------------------")

    setViewAnalysisVisible(true);
  }
  function showResult (){

    let classLabel = 1 >= 0 ? 'metric-card positive' : 'metric-card negative';

    const ctx = document.getElementById('chartCanvas');
    // Destruir gráfico anterior si existe
    if (window.myChart instanceof Chart) {
      window.myChart.destroy();
    }
    
    window.myChart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: ['Revenue', 'ESC Revenue', 'Compensation', 'ESC Compensation', 'Rev Neto', 'ESC Rev Neto'],
            datasets: [{
                label: 'Valores',
                data: [
                    1192333412,
                    412124543,
                    1212333333,
                    913123121,
                    1234555467,
                    623121233
                ],
                backgroundColor: [
                    'rgba(59, 130, 246, 0.8)',
                    'rgba(99, 102, 241, 0.8)',
                    'rgba(251, 146, 60, 0.8)',
                    'rgba(250, 204, 21, 0.8)',
                    'rgba(34, 197, 94, 0.8)',
                    'rgba(168, 85, 247, 0.8)'
                ],
                borderColor: [
                    'rgba(59, 130, 246, 1)',
                    'rgba(99, 102, 241, 1)',
                    'rgba(251, 146, 60, 1)',
                    'rgba(250, 204, 21, 1)',
                    'rgba(34, 197, 94, 1)',
                    'rgba(168, 85, 247, 1)'
                ],
                borderWidth: 2
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: 'Análisis de Métricas Financieras',
                    font: {size: 16}
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: {
                        callback: function(value) {
                            return Number(value).toLocaleString();
                        }
                    }
                }
            }
        }
    });

    const rows = [
        ['Sum of TPI', Number(12342351.012931).toLocaleString()],
        ['Sum of Supplies Spent', Number(423414143223).toLocaleString()],
        ['Sum of Compensation', Number(1232).toLocaleString()],
        ['Revenue', Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number("2345123"))],
        ['ESC (Revenue)', Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number("123512.452345"))],
        ['Compens.', Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number("76575675.4"))],
        ['ESC (Compens.)', Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number("4354534.789789789789789"))],
        ['Rev Neto', Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number("7567562342"))],
        ['ESC (Rev Neto)', Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number("12364534"))],
        ['GM%', Intl.NumberFormat('es-MX', { style: 'percent', minimumFractionDigits: 0 }).format(Number("65") / 100)]
    ];

    return (<>
      <div class="metrics-grid">
        <div  class = 'metric-card'>
          <div class="metric-label">Sum of TPI'</div>
          <div class="metric-value">{Number(6494156.64556).toLocaleString()}</div>
        </div>
        <div class = 'metric-card revenue'>
          <div class="metric-label">Rev Neto'</div>
          <div class="metric-value">{Number(589456.656).toLocaleString()}</div>
        </div>
        <div class = 'metric-card gm'>
          <div class="metric-label">Sum of TPI'</div>
          <div class="metric-value">{Number(49756.6).toLocaleString()}</div>
        </div>
        <div class = {classLabel}>
          <div class="metric-label" >Gross Margin %'</div>
          <div class="metric-value">{Number(456).toLocaleString()}</div>
        </div>
      </div>
          
      <div class="chart-container">
          <canvas id="chartCanvas"></canvas>
      </div>
      
      <table>
        <thead>
          <tr>
            <th>Métrica</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          {
            rows.map(([label, value]) => {
              return (
                <tr>
                  <td>{label}</td>
                  <td style={{textAlign: "right", fontWeight: "600"}}>{value}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </>);
  }
  
  return (<div className="analysis-page">
    <script src="https://cdn.jsdelivr.net/npm/chart.js"></script>
    <div>
      {isLoading ? <ProgressIndicator appearance="linear" /> : ''}
      <Container style={{ margin: '28px 0px' }}>
        <Row>
          <Col xs="4" md="4">
            <Select
              options={countryOptions}
              label={t('Country')}
              value={countryFilterVal}
              onChange={handleCountryFilterChange}
              onClear={() => { handleCountryFilterChange({ value: 'noFiltered' }) }}
              disabled={isLoading}
            />
          </Col>
          <Col xs="4" md="4">
            <Select
              options={channelOptions}
              label={t('channel')}
              value={channelFilterVal}
              // onChange={handleChannelFilterChange}
              onChange={handleChannelFilterChange}
              onClear={() => { handleChannelFilterChange({ value: 'noFiltered' }) }}
              disabled={isLoading}
            />
          </Col>
          <Col xs="4" md="4">
            <Select
              options={endUserOptions}
              label={t('specialcondition.enduser')}
              value={endUserFilterVal}
              onChange={handleEndUserFilterChange}
              onClear={() => { handleEndUserFilterChange({ value: 'noFiltered' }) }}
              disabled={isLoading}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '16px' }}>
          <Col xs="4" md="4">
            <Select
              options={seriesOptions}
              label={t('series')}
              value={seriesFilterVal}
              onChange={handleSeriesFilterChange}
              onClear={() => { handleSeriesFilterChange({ value: 0 }) }}
              disabled={isLoading}
            />
          </Col>
          <Col xs="4" md="4">
            <Select
              options={modelOptions}
              label={t('model')}
              value={modelFilterVal}
              onChange={handleModelFilterChange}
              onClear={() => { handleModelFilterChange({ value: 'noFiltered' }) }}
              disabled={isLoading}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '16px' }}>
          <Col xs="4" md="4">
            <Select
              options={dateOptions}
              label={t('specialcondition.startdate')}
              value={startDateFilterVal}
              onChange={(e) => { setStartDateFilterVal([e.value]) }}
              onClear={() => { setStartDateFilterVal([dateOptions[dateOptions.length - 1].value]) }}
              disabled={isLoading}
            />
          </Col>
          <Col xs="4" md="4">
            <Select
              options={dateOptions}
              label={t('specialcondition.enddate')}
              value={endDateFilterVal}
              onChange={(e) => { setEndDateFilterVal([e.value]) }}
              onClear={() => { setEndDateFilterVal([dateOptions[dateOptions.length - 1].value]) }}
              disabled={isLoading}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '16px' }}>
          <Col xs="12" md="6">
            
            <Button
              style={{ marginRight: '16px' }}
              leadingIcon={<IconDownload />}
              onClick={() => {GetReport();}}
              disabled={false}
              loading={isLoading}
              title={t('download data')}
            >
              {t('runReport')}
            </Button>
            <Button
              leadingIcon={<IconFilter />}
              disabled={false}
              loading={isLoading}
              title="Reset Filters"
              appearance="secondary"
              onClick={resetFilters}
            >
              {t('resetFilters')}
            </Button>
          </Col>
        </Row>
      </Container>
    </div> <br />

    {viewAnalysisVisible?(
      <div class="card" style={{marginLeft: "15px"}}>
        <h3 style={{marginBottom: "1.5rem", color: "#1e3a8a"}}>
            Resultados del Análisis 
            <span style={{marginLeft: "10px", fontSize: "1.3rem", color: "#64748b"}}> { moment(startDate).format("MMMM-YYYY")} - {moment(endDate).format("MMMM-YYYY")}</span>
        </h3>
        {showResult()}
      </div>
    ):(<></>)}
  </div>);
};

export default TPIReport;
